
import React from 'react';
import { ReportIntroduction } from "@/components/insights/ReportIntroduction";
import { ReportFormData } from "@/components/ReportForm/formSchema";

interface CoverSectionProps {
  isDialogOpen: boolean;
  setIsDialogOpen: (isOpen: boolean) => void;
  isSuccess: boolean;
  onFormSubmit: (data: ReportFormData) => void;
  isLoading: boolean;
  title: string;
  pdfPath: string;
}

export const CoverSection: React.FC<CoverSectionProps> = ({
  isDialogOpen,
  setIsDialogOpen,
  isSuccess,
  onFormSubmit,
  isLoading,
  title,
  pdfPath
}) => {
  return (
    <div className="mb-16">
      <ReportIntroduction 
        isDialogOpen={isDialogOpen} 
        setIsDialogOpen={setIsDialogOpen}
        isSuccess={isSuccess}
        onFormSubmit={onFormSubmit}
        isLoading={isLoading}
        title={title}
        pdfPath={pdfPath}
      />
      <div className="relative rounded-lg overflow-hidden mb-8">
        <img 
          src="/lovable-uploads/554fa1be-e384-4a34-8c08-ad2065e47ed0.png" 
          alt="AI in Small Law Firms" 
          className="w-full object-cover"
        />
      </div>
      <div className="prose prose-invert max-w-none">
        <p className="text-xl text-white/80">
          This exclusive report reveals how small and mid-sized law firms are leveraging AI technology to
          compete with larger practices, streamline operations, and deliver better client service—all while
          maintaining profitability and work-life balance.
        </p>
      </div>
    </div>
  );
};

export default CoverSection;
